export default __webpack_public_path__ + "static/media/logo.04b8bec7.png";